__turbopack_context__.v({
  "className": "source_serif_4_ca86ed33-module___blX-q__className",
  "variable": "source_serif_4_ca86ed33-module___blX-q__variable",
});
